import { IonItem, IonLabel, IonNote } from '@ionic/react';
import React from 'react';
import { Case } from '../../../services/buildfire/rdb/cases';
import { useHistory } from 'react-router-dom';

interface SubmitterInfoProps {
  case: Case;
}

const SubmitterInfo: React.FC<SubmitterInfoProps> = ({ case: c }) => {
  const history = useHistory();

  return (
    <IonItem
      button
      detail
      id="case-info_submitter-info"
      onClick={(e) => {
        history.push(`${c.id}/edit-submitter`, { from: 'caseInfo' });
      }}
    >
      <IonLabel>
        Veterinarian Info
        <br />
        <IonNote style={{ display: 'flex' }}>
          {c.submitter.first} {c.submitter.last} - {c.submitter.email}
        </IonNote>
      </IonLabel>
    </IonItem>
  );
};

export default SubmitterInfo;
